// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CyTQ","name":"styles_name__gbF6s","phone":"styles_phone__3d8x9"};